module.exports = __webpack_public_path__ + "img/techworks.1366948e.png";